<template>
  <div class="flex flex-between flex-vertical-center step-item">
    <div class="mr-100">
      <h3 class="sequence--label">{{ sequence.label }}</h3>
      <p class="sequence--description">{{ sequence.description }}</p>
    </div>

    <form-field-switch
      v-model="sequence.include"
      label="Include?"
      @change="updateSequence"
      is-left-label
    />
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "StepItemSequence",
  props: {
    sequence: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateSequence(include) {
      if(include) {
        this.$store.commit('onboarding/addFollowUp', this.sequence);
      } else {
        this.$store.commit('onboarding/deleteFollowUp', this.sequence);
      }
    }
  },
})
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.step-item {
  max-width: 500px;
  padding: 8px;

  &:nth-of-type(odd) {
    background-color: $background;
  }
}

.sequence {
  &--label {
    margin-bottom: 4px;
    font-size: 0.75rem;
  }

  &--description {
    line-height: 1.3;
  }
}
</style>
